/**
 * Token amounts: an integer of base units at the token's own scale, or the
 * exact decimal string one becomes. Bigint and string arithmetic only, from
 * the wire to the printed figure. A float holds about sixteen significant
 * digits, so it reads a 0.001 minimum as "0", a price of 0.0000085 as "0",
 * drops the low digits of anything past 2^53, and rounds a tie up or down
 * depending on how the double happens to be stored.
 *
 * The scale (`decimals`) is the token's, from `src/config` or the served
 * record: USDC and USDT are 6, DAI is 18. Never assumed.
 */
/** "1234567" → "1,234,567": thousands separators on a run of digits. */
export function groupThousands(digits: string): string {
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
